import { createSlice } from "@reduxjs/toolkit";
import { createGenericReducers, loadingSideEffects, RTKSideEffectSchema, successSideEffects } from "..";
import { APIErrorResponseSchema } from "../../actions";
import { CurrentOrganizationSlice, OrganizationSlice } from "../organizations/organization";

interface TrialLimitState extends APIErrorResponseSchema {
  SMS: {
    Total: number;
    Used: number;
  };
  Email: {
    Total: number;
    Used: number;
  };
  App: {
    Total: number;
    Used: number;
  };
  User: {
    Total: number;
    Used: number;
  };
  Organizations: {
    Total: number;
    Used: number;
  };
  OrgIDP: {
    Total: number;
    Used: number;
  };
}

const initialState: TrialPlanLimitSchema = {
  Data: {
    SMS: {
      Total: 0,
      Used: 0
    },
    Email: {
      Total: 0,
      Used: 0
    },
    App: {
      Total: 0,
      Used: 0
    },
    User: {
      Total: 0,
      Used: 0
    },
    Organizations: {
      Total: 0,
      Used: 0
    },
    OrgIDP: {
      Total: 0,
      Used: 0
    }
  },
  isError: false,
  isSuccess: false,
  isLoading: false,
  isDeleting: false,
  isUpdating: false
};
interface TrialLimitRequest {
  isB2B?: boolean;
}
export interface TrialPlanLimitSchema extends RTKSideEffectSchema, APIErrorResponseSchema {
  Data?: TrialLimitState;
}

const trialLimitSlice = createSlice({
  name: "trialLimit",
  initialState,
  reducers: {
    getTrialPlanLimitsRequest: createGenericReducers<TrialPlanLimitSchema, TrialLimitRequest>({}).request,
    getTrialPlanLimitsSuccess: createGenericReducers<TrialPlanLimitSchema, TrialLimitState>({}).success,
    getTrialPlanLimitsError: createGenericReducers<TrialLimitState, string>({}).failure
  },
  extraReducers: (builder) => {
    (builder.addCase(OrganizationSlice.actions.addOrganizationRequest, (state) => {
      Object.assign(state, loadingSideEffects);
    }),
      builder.addCase(OrganizationSlice.actions.addOrganizationSuccess, (state) => {
        Object.assign(state, successSideEffects);
        state.Data.Organizations.Used += 1;
      }));
    builder.addCase(OrganizationSlice.actions.addOrganizationFailure, (state) => {
      Object.assign(state, successSideEffects);
    });
    builder.addCase(OrganizationSlice.actions.deleteOrganizationRequest, (state) => {
      Object.assign(state, loadingSideEffects);
    });
    builder.addCase(OrganizationSlice.actions.deleteOrganizationSuccess, (state, action) => {
      Object.assign(state, successSideEffects);

      state.Data.Organizations.Used -= 1;
      if (action.payload.Connections && action.payload.Connections.length > 0) {
        state.Data.OrgIDP.Used -= action.payload.Connections.length;
      }
    });
    builder.addCase(OrganizationSlice.actions.deleteOrganizationFailure, (state) => {
      Object.assign(state, successSideEffects);
    });
    builder.addCase(CurrentOrganizationSlice.actions.createConnectionForCurrentOrganizationRequest, (state) => {
      Object.assign(state, loadingSideEffects);
    });
    builder.addCase(CurrentOrganizationSlice.actions.createConnectionForCurrentOrganizationSuccess, (state) => {
      Object.assign(state, successSideEffects);
      state.Data.OrgIDP.Used += 1;
    });
    builder.addCase(CurrentOrganizationSlice.actions.createConnectionForCurrentOrganizationFailure, (state) => {
      Object.assign(state, successSideEffects);
    });
    builder.addCase(CurrentOrganizationSlice.actions.deleteConnectionForCurrentOrganizationRequest, (state) => {
      Object.assign(state, loadingSideEffects);
    });
    builder.addCase(CurrentOrganizationSlice.actions.deleteConnectionForCurrentOrganizationSuccess, (state) => {
      Object.assign(state, successSideEffects);
      state.Data.OrgIDP.Used -= 1;
    });
    builder.addCase(CurrentOrganizationSlice.actions.deleteConnectionForCurrentOrganizationFailure, (state) => {
      Object.assign(state, successSideEffects);
    });
  }
});

export const { getTrialPlanLimitsError, getTrialPlanLimitsRequest, getTrialPlanLimitsSuccess } = trialLimitSlice.actions;

export default trialLimitSlice.reducer;
